/**
 * Azioni della card (completa, modifica, cronologia, elimina), in alto a destra.
 *
 * Sempre fuori dal flusso del contenuto: prima, sui dispositivi senza mouse,
 * il cluster scivolava in linea sopra il titolo. Ora e' assoluto in ogni caso,
 * con uno sfondo che lo tiene leggibile se un titolo lungo ci passa sotto.
 * Sul desktop compare al passaggio del mouse, sul touch resta visibile.
 */
import React from 'react';

export const CardActions: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Sulle card in sola lettura non c'e' nessuna azione: niente riquadro vuoto.
  if (!React.Children.toArray(children).some(Boolean)) return null;
  return (
  <div className="absolute right-2 top-2 z-[1] flex gap-0.5 rounded-md border border-[rgba(55,53,47,0.09)] bg-white px-0.5 opacity-0 shadow-sm transition-opacity group-hover:opacity-100 dark:border-[#3F4447] dark:bg-[#2F3437] [@media(hover:none)]:opacity-100">
    {children}
  </div>
);
};
